export default { sha: 'bdc395421cac88af8d30b3ff600a25578068ea8a', buildNumber: 'undefined' }
